export const API_STATUS = "API_STATUS";
export const GET_SITE = "GET_SITE";
export const UPDATE_SITE = "UPDATE_SITE";
export const DELETE_SITE = "DELETE_SITE";
export const ADD_SITE = "ADD_SITE";
export const APPROVE_SITE = "APPROVE_SITE";
